import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../redux/actions/menuActions";
import SectorsContainer from "../../containers/metier/sectors/SectorsContainer";
import MenuMetier from "./Menu";

class Sectors extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("metier");
    this.props.setMenuLeftIndex("basepdc");
    this.props.setMenuLeftContent(MenuMetier);
    this.props.setMenuLeftItemIndex("sectors");
  }
  render() {
    return (
      <Fragment>
        <div class="p-content-page-center">
          <div class="p-content-page-center-header">
            <h2 class="p-content-page-center-header-title">Liste des secteurs</h2>
          </div>
          <SectorsContainer {...this.props} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sectors);



// WEBPACK FOOTER //
// src/pages/metier/Sectors.js